<div *ngIf="queryFilter$ | async"><!-- trigger loading queryFilter --></div>

<div *ngIf="patientAppointments$ | async as patientAppointments">
  <div style="padding-top: 16px; width: 100%">
    <ng-appointment-list [appointments]="patientAppointments"
                         [loading]="loading$ | async"
                         [strategies]="strategies$ | async"
                         [urlType]="'patient'"
                         [queryFilter]="queryFilter$ | async"
                         [currentUser]="currentUser$ | async"
                         [selectedFromDate]="fromDate"
                         [selectedToDate]="toDate"
                         (loadDataOnScroll)="getMoreAppointmentsOnScroll(patientAppointments.length)"
    ></ng-appointment-list>

  </div>
</div>